import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GenericDialog } from "@/components/dialogs";
import { Region } from "@/api/williams/region";
import { useEffect, useState } from "react";

import styles from "./RegionSelection.tsx.module.scss";

export type RegionSelectionProps = {
  caption: string;
  options: Region[];
  selected: Region[];
  onAccept: (values: Region[]) => void;
};

export function RegionSelection(props: RegionSelectionProps) {
  const [itemsLeft, setItemsLeft] = useState<Region[]>([]);
  const [itemsRight, setItemsRight] = useState<Region[]>([]);
  const [selectedItemLeft, setFocusedItemLeft] = useState<Region>();
  const [selectedItemRight, setFocusedItemRight] = useState<Region>();

  useEffect(() => {
    if (props.options) {
      setInitialData(props.options);
    }
  }, [props.options]);

  function setInitialData(items: Region[]) {
    // Ensure everything uses the same object instance.
    const selected = items.filter((item) => props.selected.some((x) => x.id === item.id));
    const left = items.filter((item) => !selected.includes(item));
    const right = items.filter((item) => selected.includes(item));

    if (left.length > 0) {
      setItemsLeft(left);
      setFocusedItemLeft(left[0]);
    }
    if (right.length > 0) {
      setItemsRight(right);
      setFocusedItemRight(right[0]);
    }
  }

  function handleAdd() {
    if (selectedItemLeft) {
      const left = itemsLeft.filter((item) => item !== selectedItemLeft);
      const right = [...itemsRight, selectedItemLeft];
      setItemsLeft(left);
      setItemsRight(right);
      setFocusedItemLeft(left.length > 0 ? left[0] : undefined);
      setFocusedItemRight(selectedItemLeft);
    }
  }

  function handleRemove() {
    if (selectedItemRight) {
      const left = [...itemsLeft, selectedItemRight];
      const right = itemsRight.filter((item) => item !== selectedItemRight);
      setItemsLeft(left);
      setItemsRight(right);
      setFocusedItemLeft(selectedItemRight);
      setFocusedItemRight(right.length > 0 ? right[0] : undefined);
    }
  }

  return (
    <GenericDialog
      caption={props.caption}
      buttons="OKCancel"
      className={styles.dialog}
      onAccept={() => props.onAccept(itemsRight)}
    >
      <div className="d-flex align-middle">
        <select
          className={"form-select"}
          size={8}
          value={selectedItemLeft?.id}
          onChange={(e) => setFocusedItemLeft(itemsLeft.find((x) => x.id === e.currentTarget.value))}
        >
          {itemsLeft?.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>
        <div className="mt-5 p-1">
          <button className="btn btn-default m-1 ps-3 pe-3" onClick={handleAdd} disabled={!selectedItemLeft}>
            <FontAwesomeIcon icon={faArrowRight} size="sm" />
          </button>
          <button className="btn btn-default m-1 ps-3 pe-3" onClick={handleRemove} disabled={!selectedItemRight}>
            <FontAwesomeIcon icon={faArrowLeft} size="sm" />
          </button>
        </div>
        <select
          className="form-select"
          size={8}
          value={selectedItemRight?.id}
          onChange={(e) => setFocusedItemRight(itemsRight.find((x) => x.id === e.currentTarget.value))}
        >
          {itemsRight?.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>
      </div>
    </GenericDialog>
  );
}
